<p8-settings-page>
  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <p8-settings-header [titlePath]="['Messages']"></p8-settings-header>
    <button
      mat-raised-button
      (click)="ExportAllFeedbacks()"
      matTooltip="Export Excel de toutes les messages"
      style="cursor: pointer;">
      <i class="fa fa-file-excel-o fa-2x" aria-hidden="true" ></i>
    </button>
  </div>
  <app-data-table
    [dataSource]="dsFeedbacks"
    [extraParams]="extraParams"
    [filterDisplay]="true"
    [placeHolderFilter]="'Rechercher un message'"
    [toolTipFilter]="'Rechercher un message'"
    [flexAction]="5" [flexColumn]="90"
    [pageSize]="10" [pageSizesList]="[5,10,25]"
    [columns]="columns" [actions]="actions"
    [refreshButton]="true"
    [showLoader]="true"
    class="p8-cm_data-table__search-full-width">
  </app-data-table>
</p8-settings-page>
